export default {
  name: 'ErrorOverview',
  components: {},
  props: {},
  data: () => ({

  }),
  computed: {},
  methods: {},
};
